import React from 'react';
import MalwareMap from "../map/malwareMap";

const MalwareModule = () => {
    return (
    <MalwareMap/>
)
}
export default MalwareModule;